module.exports = __webpack_public_path__ + "static/media/summerscholarprogram.2482fe88.webp";